import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';

// Your Firebase configuration
// Replace with your actual Firebase config
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyCluqPhGvaiG2jKeEVKlTO-u3DCdAQDN9k",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "retirementpro-c2d50.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "retirementpro-c2d50",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "retirementpro-c2d50.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "321598447522",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:321598447522:web:b4792a85868fd6eccb9cfb",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-85LGYTP1CB",
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL || "https://retirementpro-c2d50.firebaseio.com"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const database = getDatabase(app);
export const googleProvider = new GoogleAuthProvider();

// Set persistence to LOCAL to maintain auth state across page reloads
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error('Error setting auth persistence:', error);
});

// Configure Google Auth Provider
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app; 